import { render, staticRenderFns } from "./ModelTwo.vue?vue&type=template&id=5071a7b8&scoped=true"
import script from "./ModelTwo.vue?vue&type=script&lang=js"
export * from "./ModelTwo.vue?vue&type=script&lang=js"
import style0 from "./ModelTwo.vue?vue&type=style&index=0&id=5071a7b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5071a7b8",
  null
  
)

export default component.exports